import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

function getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

// Attach the double-submit CSRF token on state-changing requests (cookie auth)
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    // Prefer an explicitly set default header (set right after login/register to avoid
    // a race where the freshly-set csrf_token cookie isn't yet readable); fall back to cookie.
    if (!config.headers["X-CSRF-Token"]) {
      const csrf = getCookie("admin_csrf_token") || getCookie("csrf_token");
      if (csrf) config.headers["X-CSRF-Token"] = csrf;
    }
  }
  return config;
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
